import { useSyncExternalStore } from 'react';

/**
 * 아침 브리핑 팝업이 지금 화면에 떠 있는가.
 *
 * 게이트(`MorningBriefingGate`)는 라우트 바깥(`PrivateRoutes`)에 있어서, 화면 안쪽에서 띄우는
 * 다른 안내 팝업(예: 세션 현황 화면 안내)이 그 상태를 알 길이 없다. 둘이 겹치면
 * 원장님은 무엇을 닫은 건지 모른다 — 업데이트 소식 팝업과 같은 이유다(`updatePopupContext`).
 * 컨텍스트로 감싸려면 라우트 구조를 바꿔야 해서, 게이트가 값을 쓰고 화면이 읽는 작은 저장소로 둔다.
 */
let open = false;
const listeners = new Set<() => void>();

export const setMorningBriefingOpen = (next: boolean) => {
    if (open === next) return;
    open = next;
    listeners.forEach((l) => l());
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

export const useMorningBriefingOpen = () => useSyncExternalStore(subscribe, () => open, () => false);
